/**
 * Les deux issues d'une élévation du second facteur qui ne rejouent pas le
 * geste (ARTO-58) : la personne a fermé la boîte, ou l'API a de nouveau refusé
 * après une vérification acceptée. Dans un fichier à part pour que
 * `erreursSaisie.ts` les lise sans dépendre d'un composant.
 */

/** La personne a fermé la boîte sans vérifier : le geste n'est pas rejoué. */
export class ElevationAnnulee extends Error {
  constructor() {
    super('Vérification du second facteur annulée.');
    this.name = 'ElevationAnnulee';
  }
}

/** L'API redemande l'élévation alors qu'elle vient d'être acceptée : on ne boucle pas. */
export class ElevationNonAcceptee extends Error {
  constructor() {
    super('Vérification du second facteur non acceptée.');
    this.name = 'ElevationNonAcceptee';
  }
}

export function estElevationAnnulee(erreur: unknown): erreur is ElevationAnnulee {
  return erreur instanceof ElevationAnnulee;
}

export function estElevationNonAcceptee(erreur: unknown): erreur is ElevationNonAcceptee {
  return erreur instanceof ElevationNonAcceptee;
}
